import * as React from 'react';
import { ListItemText as MatListItemText, SxProps, Theme } from '@mui/material';

export interface ListItemTextProps {
  className?: string;
  disableTypography?: boolean;
  primary: React.ReactNode;
  primaryTypographyProps?: object;
  secondary?: React.ReactNode;
  secondaryTypographyProps?: object;
  inset?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onDoubleClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  sx?: SxProps<Theme>;
}

const ListItemText: React.FC<ListItemTextProps> = ({ className, primary, secondary, inset, sx }) => {
  return <MatListItemText className={className} sx={sx} primary={primary} secondary={secondary} inset={inset} />;
};

ListItemText.defaultProps = {
  inset: false
};

ListItemText.displayName = 'ListItemText';

export { ListItemText };
